export default "__VITE_ASSET__B9aVf9Pc__"